module.exports = __webpack_public_path__ + "img/icon15.dbea3f4c.svg";